(() => {
  if (!customElements.get('va-collection-shop')) {
    customElements.define('va-collection-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const source = this.querySelector('[data-va-variants]');
        this.selector = this.querySelector('[data-va-variant-selector]');
        this.form = this.querySelector('form');
        if (!source || !this.selector || !this.form) return;
        try { this.variants = JSON.parse(source.textContent); } catch { return; }
        this.radios = [...this.querySelectorAll('[data-va-option]')];
        this.optionCount = this.variants[0]?.options.length || 0;
        if (!this.variants.length || !this.radios.length) return;
        this.setAttribute('data-enhanced', '');
        this.addEventListener('change', event => {
          if (event.target.matches('[data-va-option]')) {
            const selected = Array.from({length: this.optionCount}, (_, index) => this.querySelector(`[data-va-option="${index}"]:checked`)?.value);
            const changedIndex = Number(event.target.dataset.vaOption);
            let variant = this.variants.find(item => item.options.every((value, index) => value === selected[index]));
            if ((!variant || !variant.available) && changedIndex === 0) variant = this.variants.find(item => item.available && item.options[0] === selected[0]);
            this.updateVariant(variant);
            this.refreshAvailability(variant?.options || selected);
          } else if (event.target === this.selector) {
            this.updateVariant(this.variants.find(item => String(item.id) === this.selector.value));
          }
        });
        this.addEventListener('click', event => {
          const photo = event.target.closest('[data-va-photo]');
          if (!photo || !this.contains(photo)) return;
          const image = this.querySelector('[data-va-shop-image]');
          if (!image) return;
          image.src = photo.dataset.src;
          image.srcset = photo.dataset.srcset;
          image.alt = photo.dataset.alt;
          this.querySelectorAll('[data-va-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === photo)));
          if (!matchMedia('(prefers-reduced-motion: reduce)').matches && image.animate) {
            image.animate([{opacity:.55,transform:'scale(1.025)'},{opacity:1,transform:'scale(1)'}],{duration:380,easing:'cubic-bezier(.2,.65,.3,1)'});
          }
        });
        const variant = this.variants.find(item => String(item.id) === this.selector.value);
        if (variant) {
          this.updateVariant(variant);
          this.refreshAvailability(variant.options);
        }
      }
      updateVariant(variant) {
        const add = this.querySelector('[data-va-add]');
        if (!variant) {
          add.disabled = true;
          add.querySelector('span').textContent = add.dataset.unavailableLabel;
          return;
        }
        this.selector.value = String(variant.id);
        this.querySelector('[data-va-shop-price]').textContent = variant.price;
        this.querySelector('[data-va-shop-unit]').textContent = variant.unit;
        this.querySelector('[data-va-shop-chosen]').textContent = variant.title;
        this.querySelector('[data-va-shop-link]').href = variant.url;
        this.querySelector('[data-va-shop-reviews]').href = `${variant.url}#Description`;
        add.disabled = !variant.available;
        add.removeAttribute('aria-disabled');
        add.querySelector('span').textContent = variant.available ? add.dataset.addLabel : add.dataset.unavailableLabel;
        this.radios.forEach(input => { input.checked = variant.options[Number(input.dataset.vaOption)] === input.value; });
        const error = this.querySelector('.product-form__error-message-wrapper');
        if (error) error.hidden = true;
      }
      refreshAvailability(selected) {
        this.radios.forEach(input => {
          const index = Number(input.dataset.vaOption);
          const candidate = [...selected];
          candidate[index] = input.value;
          input.disabled = !this.variants.some(item => item.available && (index === 0 ? item.options[0] === input.value : item.options.every((value, position) => value === candidate[position])));
        });
      }
    });
  }
  const start = scope => {
    scope.querySelectorAll('[data-va-collection]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const items = [...root.querySelectorAll('[data-va-reveal]')];
      items.forEach(item => { if (item.getBoundingClientRect().top < innerHeight) item.classList.add('is-visible'); });
      root.setAttribute('data-motion', '');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: 0.05, rootMargin:'0px 0px 30px 0px'});
      items.forEach(item => observer.observe(item));
    });
  };
  start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
